export default "__VITE_ASSET__CAGT$fHO__"